import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { DocumentComposer } from './composer';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DocumentComposer />
  </StrictMode>,
);
